import { Wrapper, Content, HeroImageWrapper, HeroLink } from './Hero.styles';
import HeroSVG from '@public/home/hero.svg';

export default function Hero() {
  return (
    <Wrapper>
      <Content>
        <h1>
          <b>10x</b> your <b>DeFi yield,</b>
          <br />
          safely and securely
        </h1>
        <h4>
          Archimedes selects battle tested yield-bearing stablecoins and leverages them up to 10x, producing a
          sustainable &apos;Top of Market&apos; APY
        </h4>
        <HeroLink size="lg" variant="button" href="/open-position">
          Open 10x Position
        </HeroLink>
        <br />
        <HeroLink size="lg" variant="outline" href="/earn">
          Earn Passive APY
        </HeroLink>
        <br />
        <HeroLink variant="thick" href="https://docs.archimedesfi.com/" target="_blank">
          User Docs
        </HeroLink>
      </Content>
      <HeroImageWrapper>
        <HeroSVG />
      </HeroImageWrapper>
    </Wrapper>
  );
}
